if(!customElements.get('add-cart-with-discount')) {
  class ComponentAddCartWithDiscount extends HTMLElement {
    constructor() {
      super();
      this.code = this.dataset.code;
      this.button = this.querySelector(".quick-add__submit");
      this.form = this.querySelector("form");

      this.button.addEventListener('click', ()=>{
        if(this.code){
          const formData = new FormData(this.form);      
            $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: Object.fromEntries(formData.entries()),
            dataType: 'json',
            success: (data) => {
              window.location.href = `/discount/${this.code}?redirect=/cart`;
            },
            error: function(data) {
              console.log("Error adding to cart", data);
            }
          });   

        } 
        else{
          this.form.submit();
        }

        
      })



    }



  }
  customElements.define('add-cart-with-discount', ComponentAddCartWithDiscount);
}